import { State } from "@App/state";

export const selectInitialRegistrationDate = (s: State) =>
  s.orders.initialRegistrationDate ? new Date(s.orders.initialRegistrationDate) : null;

export const selectNetworkId = (s: State) =>
  s.auth?.driverData?.network?.id ?? s.orders.network?.id ?? null;
